<template>
  <div>
    <page-header></page-header>
    <main-content />
    <div class="stats container">
      <div class="row">
        <div class="col-12 col-md-6" data-aos="zoom-in-up">
          <div class="stats__placeholder">
            <div class="row no-gutters row-table margin-bottom">
              <div class="col-3 align-left">Born</div>
              <div class="col-9 align-right">
                July 28, 1983 (age 36) Malmö, Sweden
              </div>
            </div>

            <div class="row no-gutters row-table margin-bottom">
              <div class="col-3 align-left">Residence</div>
              <div class="col-9 align-right">
                Stockholm, Sweden
              </div>
            </div>

            <div class="row no-gutters row-table margin-bottom">
              <div class="col-3 align-left">Nationality</div>
              <div class="col-9 align-right">
                Sweden
                <svg
                  width="20"
                  height="20"
                  version="1.1"
                  id="Countryflags.com"
                  xmlns:x="&ns_extend;"
                  xmlns:i="&ns_ai;"
                  xmlns:graph="&ns_graphs;"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="494.5 802.75 300 187.5"
                  enable-background="new 494.5 802.75 300 187.5"
                  xml:space="preserve"
                >
                  <switch>
                    <foreignObject
                      requiredExtensions="&ns_ai;"
                      x="0"
                      y="0"
                      width="1"
                      height="1"
                    >
                    </foreignObject>
                    <g i:extraneous="self">
                      <g>
                        <rect
                          id="_x33_"
                          x="494.5"
                          y="802.75"
                          fill="#005293"
                          width="300"
                          height="187.5"
                        />
                        <rect
                          id="_x32_"
                          x="588.25"
                          y="802.75"
                          fill="#FECB00"
                          width="37.5"
                          height="187.5"
                        />
                        <rect
                          id="_x31_"
                          x="494.5"
                          y="877.75"
                          fill="#FECB00"
                          width="300"
                          height="37.5"
                        />
                      </g>
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
            <div class="row no-gutters row-table margin-bottom">
              <div class="col-3 align-left">Height</div>
              <div class="col-9 align-right">
                5 ft 10 in (1.78 m)
              </div>
            </div>
            <div class="row no-gutters row-table">
              <div class="col-3 align-left">Weight</div>
              <div class="col-9 align-right">
                247 lb (112 kg; 17.6 st)
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-6" data-aos="zoom-in-up">
          <div class="stats__placeholder">
            <div class="row no-gutters row-table margin-bottom">
              <div class="col-3 align-left">Division</div>
              <div class="col-9 align-right">
                Heavyweight (2008, 2019–present)
              </div>
            </div>
            <div class="row no-gutters row-table margin-bottom">
              <div class="col-3 align-left">Reach</div>
              <div class="col-9 align-right">
                73 in (185 cm)
              </div>
            </div>
            <div class="row no-gutters row-table margin-bottom">
              <div class="col-3 align-left">Style</div>
              <div class="col-9 align-right">
                Boxing, Wrestling
              </div>
            </div>

            <div class="row no-gutters row-table margin-bottom">
              <div class="col-3 align-left">Fighting out of</div>
              <div class="col-9 align-right">
                Sweden
                <svg
                  width="20"
                  height="20"
                  version="1.1"
                  id="Countryflags.com"
                  xmlns:x="&ns_extend;"
                  xmlns:i="&ns_ai;"
                  xmlns:graph="&ns_graphs;"
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="494.5 802.75 300 187.5"
                  enable-background="new 494.5 802.75 300 187.5"
                  xml:space="preserve"
                >
                  <switch>
                    <foreignObject
                      requiredExtensions="&ns_ai;"
                      x="0"
                      y="0"
                      width="1"
                      height="1"
                    >
                    </foreignObject>
                    <g i:extraneous="self">
                      <g>
                        <rect
                          id="_x33_"
                          x="494.5"
                          y="802.75"
                          fill="#005293"
                          width="300"
                          height="187.5"
                        />
                        <rect
                          id="_x32_"
                          x="588.25"
                          y="802.75"
                          fill="#FECB00"
                          width="37.5"
                          height="187.5"
                        />
                        <rect
                          id="_x31_"
                          x="494.5"
                          y="877.75"
                          fill="#FECB00"
                          width="300"
                          height="37.5"
                        />
                      </g>
                    </g>
                  </switch>
                </svg>
              </div>
            </div>
            <div class="row no-gutters row-table">
              <div class="col-3 align-left">Wrestling</div>
              <div class="col-9 align-right">
                Swedish national level
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <section class="container heading" data-aos="fade-up">
      <heading :text="'Stats'"></heading>
    </section>
    <section class="container stats">
      <div class="row">
        <div class="col-12 col-md-10 offset-md-1">
          <div
            class="stats__placeholder"
            data-aos="fade-up"
            data-aos-offset="300"
            data-aos-easing="ease-in-sine"
          >
            <div class="circle-wrapper row">
              <div class="col-12 col-md-4">
                <span class="circle-wrapper__heading">WINS BY KNOCKOUT</span>
                <span class="circle-wrapper__value">6</span>
                <progress-bar :value="40" :options="options" />
              </div>

              <div class="col-12 col-md-4">
                <span class="circle-wrapper__heading">WINS BY DECISION</span>
                <span class="circle-wrapper__value">4</span>
                <progress-bar :value="27" :options="options" />
              </div>
              <div class="col-12 col-md-4">
                <span class="circle-wrapper__heading">WINS BY SUBMISSION</span>
                <span class="circle-wrapper__value">5</span>
                <progress-bar :value="33" :options="options" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="container heading" data-aos="fade-up">
      <heading :text="'Upcoming events'"></heading>
    </section>

    <section class="upcoming-events container" data-aos="fade-up">
      <img src="../assets/event.jpg" alt="events" />
      <span class="upcoming-events__badge">Event passed</span>
    </section>
    <video-features data-aos="fade-up"></video-features>
    <footer-page></footer-page>
  </div>
</template>

<script>
// @ is an alias to /src
import MainContent from "@/components/mainContent.vue";
import Header from "@/components/header.vue";
import Footer from "@/components/footer.vue";
import FeaturesVideo from "@/components/videoFeatures.vue";
import ProgressBar from "../../node_modules/vuejs-progress-bar/src/components/ProgressBarCircle";
export default {
  name: "home",
  components: {
    MainContent,
    "page-header": Header,
    "footer-page": Footer,
    "video-features": FeaturesVideo,
    ProgressBar
  },
  data() {
    return {
      value: 40,
      options: {
        text: {
          color: "#000",
          shadowEnable: false,
          shadowColor: "#000000",
          fontSize: 14,
          fontFamily: "Playfair Display, serif",
          dynamicPosition: false,
          hideText: false
        },

        progress: {
          color: "#e92b2b",
          backgroundColor: "#f3f2f2"
        },
        layout: {
          height: 200,
          width: 200,
          verticalTextAlign: 130,
          horizontalTextAlign: 10,
          zeroOffset: 0,
          strokeWidth: 11,
          progressPadding: 0,
          type: "circle"
        }
      }
    };
  }
};
</script>
<style lang="scss">
.stats {
  margin-bottom: 64px;
  &__placeholder {
    padding: 25px 10px;
    background: white;
    box-shadow: 0px 15px 45px -9px rgba(0, 0, 0, 0.2);
    border-radius: 4px;
    margin-bottom: 24px;
  }
  .align-left {
    text-align: left;
    font-weight: bold;
  }
  .row-table {
    &:nth-child(2n) {
      background: #f8f8f8;
    }
    padding: 5px;
  }
}
.upcoming-events {
  margin-bottom: 64px;
  position: relative;
  img {
    width: 100%;
    border-radius: 4px;
  }
  &__badge {
    position: absolute;
    padding: 3px;
    background-color: #e92b2b;
    right: 15px;
    color: white;
    font-family: "Sigmar One", cursive, sans-serif;
    font-size: 10px;
    display: block;
    top: -15px;
    @media (min-width: 576px) {
      font-size: 12px;
      padding: 5px;
    }
  }
}
.circle-wrapper {
  &__heading {
    font-weight: bold;
  }
  &__value {
    font-size: 35px;
    font-family: "Sigmar";
    font-weight: bold;
    position: absolute;
    top: 55%;
    left: 52%;
    transform: translate(-50%, -50%);
  }
  .col-12:not(:first-child) {
    margin-top: 60px;
    @media (min-width: 576px) {
      margin: 0;
    }
  }
}
</style>
